import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

/**
 * Muestra un icono de ayuda (?) que al hacer hover muestra un mensaje en un tooltip.
 */
@Component({
  selector: 'app-help-tooltip',
  standalone: true,
  imports: [CommonModule, MatTooltipModule],
  templateUrl: './help-tooltip.component.html',
  styleUrl: './help-tooltip.component.scss',
})
export class HelpTooltipComponent {
  /** Mensaje a mostrar en el tooltip al hacer hover */
  message = input.required<string>();

  /**
   * Posición del tooltip respecto al icono.
   * Valores válidos: 'above' | 'below' | 'left' | 'right'
   */
  position = input<'above' | 'below' | 'left' | 'right'>('below');
}
